import React from "react";
import MainMenu from "./MainMenu";
import SubMenu from "./SubMenu";

const Menu = () => {
	return (
		<React.Fragment>
            <MainMenu />
			{/* <SubMenu pageName={'test'}/> */}
		</React.Fragment>
	);
};

export default Menu;
